import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import LoadingButtonsTransition from './LoadingButtonsTransition';
import ClientProvider from './client';
export default createDemo(import.meta.url, LoadingButtonsTransition, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/buttons/demos/loading-transition/LoadingButtonsTransition.tsx",
    "fileName": "LoadingButtonsTransition.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Switch from '@mui/material/Switch';\nimport SaveIcon from '@mui/icons-material/Save';\nimport SendIcon from '@mui/icons-material/Send';\n\nexport default function LoadingButtonsTransition() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [loading, setLoading] = React.useState(true);\n  function handleClick() {\n    setLoading(true);\n  }\n\n  return (\n    <div>\n      <FormControlLabel\n        sx={{ display: 'block' }}\n        control={\n          <Switch\n            checked={loading}\n            onChange={() => setLoading(!loading)}\n            name=\"loading\"\n            color=\"primary\"\n          />\n        }\n        label=\"Loading\"\n      />\n      <Box sx={{ '& > button': { m: 1 } }}>\n        <Button\n          size=\"small\"\n          onClick={handleClick}\n          loading={loading}\n          variant=\"outlined\"\n          disabled\n        >\n          Disabled\n        </Button>\n        <Button\n          size=\"small\"\n          onClick={handleClick}\n          loading={loading}\n          loadingIndicator=\"Loading…\"\n          variant=\"outlined\"\n        >\n          Fetch data\n        </Button>\n        <Button\n          size=\"small\"\n          onClick={handleClick}\n          endIcon={<SendIcon />}\n          loading={loading}\n          loadingPosition=\"end\"\n          variant=\"contained\"\n        >\n          Send\n        </Button>\n        <Button\n          size=\"small\"\n          color=\"secondary\"\n          onClick={handleClick}\n          loading={loading}\n          loadingPosition=\"start\"\n          startIcon={<SaveIcon />}\n          variant=\"contained\"\n        >\n          Save\n        </Button>\n      </Box>\n      <Box sx={{ '& > button': { m: 1 } }}>\n        <Button onClick={handleClick} loading={loading} variant=\"outlined\" disabled>\n          Disabled\n        </Button>\n        <Button\n          onClick={handleClick}\n          loading={loading}\n          loadingIndicator=\"Loading…\"\n          variant=\"outlined\"\n        >\n          Fetch data\n        </Button>\n        <Button\n          onClick={handleClick}\n          endIcon={<SendIcon />}\n          loading={loading}\n          loadingPosition=\"end\"\n          variant=\"contained\"\n        >\n          Send\n        </Button>\n        <Button\n          color=\"secondary\"\n          onClick={handleClick}\n          loading={loading}\n          loadingPosition=\"start\"\n          startIcon={<SaveIcon />}\n          variant=\"contained\"\n        >\n          Save\n        </Button>\n      </Box>\n    </div>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 104,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Button from '@mui/material/Button';\nimport Box from '@mui/material/Box';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport Switch from '@mui/material/Switch';\nimport SaveIcon from '@mui/icons-material/Save';\nimport SendIcon from '@mui/icons-material/Send';\n\nexport default function LoadingButtonsTransition() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [loading, setLoading] = React.useState(true);\n  function handleClick() {\n    setLoading(true);\n  }\n\n  return (\n    <div>\n      <FormControlLabel\n        sx={{ display: 'block' }}\n        control={\n          <Switch\n            checked={loading}\n            onChange={() => setLoading(!loading)}\n            name=\"loading\"\n            color=\"primary\"\n          />\n        }\n        label=\"Loading\"\n      />\n      <Box sx={{ '& > button': { m: 1 } }}>\n        <Button\n          size=\"small\"\n          onClick={handleClick}\n          loading={loading}\n          variant=\"outlined\"\n          disabled\n        >\n          Disabled\n        </Button>\n        <Button\n          size=\"small\"\n          onClick={handleClick}\n          loading={loading}\n          loadingIndicator=\"Loading…\"\n          variant=\"outlined\"\n        >\n          Fetch data\n        </Button>\n        <Button\n          size=\"small\"\n          onClick={handleClick}\n          endIcon={<SendIcon />}\n          loading={loading}\n          loadingPosition=\"end\"\n          variant=\"contained\"\n        >\n          Send\n        </Button>\n        <Button\n          size=\"small\"\n          color=\"secondary\"\n          onClick={handleClick}\n          loading={loading}\n          loadingPosition=\"start\"\n          startIcon={<SaveIcon />}\n          variant=\"contained\"\n        >\n          Save\n        </Button>\n      </Box>\n      <Box sx={{ '& > button': { m: 1 } }}>\n        <Button onClick={handleClick} loading={loading} variant=\"outlined\" disabled>\n          Disabled\n        </Button>\n        <Button\n          onClick={handleClick}\n          loading={loading}\n          loadingIndicator=\"Loading…\"\n          variant=\"outlined\"\n        >\n          Fetch data\n        </Button>\n        <Button\n          onClick={handleClick}\n          endIcon={<SendIcon />}\n          loading={loading}\n          loadingPosition=\"end\"\n          variant=\"contained\"\n        >\n          Send\n        </Button>\n        <Button\n          color=\"secondary\"\n          onClick={handleClick}\n          loading={loading}\n          loadingPosition=\"start\"\n          startIcon={<SaveIcon />}\n          variant=\"contained\"\n        >\n          Save\n        </Button>\n      </Box>\n    </div>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 104,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Button",
      "@mui/material/Box",
      "@mui/material/FormControlLabel",
      "@mui/material/Switch",
      "@mui/icons-material/Save",
      "@mui/icons-material/Send"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
